module.exports = __webpack_public_path__ + "static/img/wariant4.92ecbb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wariant4.jpg
// module id = 1HOI
// module chunks = 1